export default "__VITE_ASSET__96175643__"